import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { NAV, EVENT } from "@/data/siteData";
import { Menu, X } from "lucide-react";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("home");
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    if (!isHome) {
      setActive("");
      return;
    }
    const onScroll = () => {
      const sections = NAV.filter((n) => n.id)
        .map((n) => document.getElementById(n.id))
        .filter(Boolean);
      const y = window.scrollY + 120;
      let current = "home";
      for (const s of sections) {
        if (s.offsetTop <= y) current = s.id;
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [isHome]);

  const renderItem = (item, testPrefix) => {
    const commonClass = "px-3 py-2 text-[13px] font-medium transition-colors";
    if (item.to) {
      const isActive = location.pathname === item.to;
      return (
        <Link
          key={item.to}
          to={item.to}
          data-testid={`${testPrefix}-int-pay`}
          onClick={() => setOpen(false)}
          className={`${commonClass} ${
            isActive ? "text-[#002FA7]" : "text-zinc-700 hover:text-[#002FA7]"
          }`}
        >
          {item.label}
        </Link>
      );
    }
    const href = isHome ? `#${item.id}` : `/#${item.id}`;
    return (
      <a
        key={item.id}
        href={href}
        data-testid={`${testPrefix}-${item.id}`}
        onClick={() => setOpen(false)}
        className={`${commonClass} ${
          isHome && active === item.id
            ? "text-[#002FA7]"
            : "text-zinc-700 hover:text-[#002FA7]"
        }`}
      >
        {item.label}
      </a>
    );
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full backdrop-blur-xl bg-white/85 border-b border-zinc-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex h-16 md:h-20 items-center justify-between">
          <Link
            to="/"
            data-testid="nav-logo"
            className="flex items-center gap-3 group"
          >
            <span className="w-9 h-9 bg-[#002FA7] text-white font-display text-sm flex items-center justify-center">
              BoT
            </span>
            <div className="leading-tight hidden sm:block">
              <div className="font-display text-base tracking-tight">BoT Summit</div>
              <div className="font-display text-[11px] uppercase tracking-[0.22em] text-zinc-500 mt-1 text-justify" style={{ textAlignLast: "justify" }}>
                Best of Tech
              </div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((item) => renderItem(item, "nav"))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={isHome ? "#registration" : "/#registration"}
              data-testid="nav-register-btn"
              className="hidden md:inline-flex items-center gap-2 bg-[#002FA7] text-white px-5 py-2.5 text-[12px] font-bold tracking-widest uppercase hover:bg-black transition-colors"
            >
              Register →
            </a>
            <button
              data-testid="nav-menu-toggle"
              onClick={() => setOpen(!open)}
              className="lg:hidden p-2 border border-zinc-300"
              aria-label="Toggle menu"
            >
              {open ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden pb-4 border-t border-zinc-200">
            <nav className="flex flex-col pt-2">
              {NAV.map((item) => renderItem(item, "mobile-nav"))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
